// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"arrow_shadow__11uzf","arrow":"arrow_arrow__1tONG","icon":"arrow_icon__3B5sx"};